<template>
  <bg-style v-if="visible" :bg="model.background" :mobile-bg="model.mobileBackground" :style="getStyle" class="collapse-widget" :class="{ 'is-mobile': $store.getters.isMobile }">
    <module-block no-padding>
      <rich-text
        v-if="model.titleVisible"
        v-model="model.title"
        :stroke.sync="model.titleStroke"
        class="collapse-title"
        :editing="editing"
        :disabled="!editing"
        placement="bottom"
      />
      <model-wrapper v-for="(child,index) in model.children" :key="index + 'item'" :model-index="index" :model="child" :parent-model="model" class="mb-2 last-of-type:mb-0">
        <bg-style :bg="model.bgConfig" class="collapse-widget__item">
          <bg-style :bg="model.bgConfig" class="title-block" @click.native="handleTitleShowContent(child)">
            <rich-text :ref="`title-${index}`" v-model="child.title" class="w-full relative" :editing="editing" :disabled="!editing" @click.native.stop="handleTitleShowContent(child)" />
            <i v-if="child.__visible" class="el-icon-arrow-down ml-5 cursor-pointer arrow" @click.stop="handleArrowShowContent(child)" />
            <i v-else class="el-icon-arrow-right ml-5 cursor-pointer arrow" @click.stop="handleArrowShowContent(child)" />
          </bg-style>
          <el-collapse-transition>
            <div v-show="child.__visible">
              <div class="content-block" :class="{ 'is-horizontal': isHorizontal }">
                <div v-if="child.blockList.length" class="image-list relative mb-5">
                  <div v-for="(block, blockIndex) in child.blockList" :key="blockIndex + 'block'" class="item">
                    <div v-if="block.thumbBackground.backgroundImageShow" class="relative min-h-[60px]" :class="{ 'min-w-[140px]': editing && isHorizontal }">
                      <img class="thumb mx-auto block" :src="block.thumbBackground.backgroundImage" alt="">
                      <cover-block v-if="editing" absolute class="top-0" @click="handleShowThumbUpload(blockIndex)" />
                    </div>
                    <rich-text v-model="block.desc" class="describe" :editing="editing" force-wrap :disabled="!editing" />
                  </div>
                </div>
                <bg-style v-if="child.descriptionShow" class="content-block__describe" :bg="model.descBackground">
                  <rich-text
                    v-model="child.description"
                    class="descriptions relative"
                    :editing="editing"
                    :disabled="!editing"
                  />
                </bg-style>
              </div>
            </div>
          </el-collapse-transition>
        </bg-style>
      </model-wrapper>
    </module-block>
  </bg-style>
</template>

<script>
import RichText from '~/components/richText/index.vue'
import ModelWrapper from '~/components/modelWrapper/index.vue'
import { getTextColor, sleep } from '~/utils'
import Bus from '~/site/model/bus'
import CoverBlock from '~/components/common/CoverBlock.vue'
import ModuleBlock from '~/components/common/ModuleBlock.vue'

export default {
  name: 'CollapseWidget',
  components: {
    ModuleBlock,
    CoverBlock,
    ModelWrapper,
    RichText
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      },
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      visible: true,
      currentIndex: -1
    }
  },
  computed: {
    isHorizontal() {
      return this.model.layoutMethod === 'horizontal'
    },
    getStyle() {
      return {
        '--arrow-color': getTextColor(this.model.arrow).color
      }
    }
  },
  mounted() {
    this.checkHandleExpand()
    Bus.$on('drag-end', () => {
      this.refresh()
    })
  },
  methods: {
    checkHandleExpand() {
      if (this.model.isExpand) {
        this.model.children.forEach((child) => {
          child.__visible = true
        })
      }
    },
    async refresh() {
      this.visible = false
      await sleep(0)
      this.visible = true
    },
    handleTitleShowContent(child) {
      if (this.editing) return
      child.__visible = !child.__visible
    },
    async handleShowThumbUpload(index) {
      await sleep(500)
      this.SiteMenu.showImageWithKey(`show-collapse-img-${index}`)
    },
    handleArrowShowContent(child) {
      child.__visible = !child.__visible
    }
  }
}
</script>

<style lang="less">
.stand-alone-mode {
  .collapse-widget__item,.title-block {
    & > .color-bg {
      border-radius: 20px !important;
    }
  }
}

.collapse-widget {
  padding: 20px 0;
  .collapse-title {
    padding: 20px 0;
  }
  &__item {
    .title-block {
      min-height: 74px;
      padding: 16px 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      line-height: 30px;
      cursor: pointer;
      .arrow {
        color: var(--arrow-color);
        position: relative;
        font-size: 24px;
        font-weight: bold;
      }
    }
    .content-block {
      padding: 0 0 40px 0;
      &__describe {
        padding: 0 30px;
      }
      &.is-horizontal {
        .image-list {
          flex-direction: column;
          .item {
            display: flex;
            align-items: center;
            .describe {
              width: 100%;
            }
          }
        }
      }
      .image-list {
        display: flex;
        flex-wrap: nowrap;
        padding: 0 30px;
        gap: 30px;
        .item {
          flex: 1;
          max-width: 100%;
          .thumb {
            //width: 100%;
          }
        }
      }
      .collapse-image {
        height: 180px;
        width: 320px;
        flex-shrink: 0;
      }
    }
  }
  &.is-mobile {
    padding: 10px;
    .collapse-title {
      padding: 10px 12px 0 12px;
    }
    .collapse-widget__item {
      .title-block {
        min-height: 60px;
        padding: 0 16px;
        font-size: 14px;
        line-height: 22px;
      }
      .content-block {
        padding: 0 0 10px 0;
        .image-list {
          padding: 0 16px;
          gap: 10px;
        }
        .descriptions {
          margin-bottom: 12px !important;
          margin-left: 0 !important;
        }
        .collapse-image {
          max-width: 100%;
        }
        &__describe {
          padding: 0 16px;
        }
      }
    }
  }
}
</style>
